import { t } from '@lingui/core/macro';

import { InstantSearch, InstantSearchSortOrder, type QueryState } from '@/components/InstantSearch';
import InstantSearchInput from '@/components/InstantSearchInput';
import { Page, PageDateRangeFilter, PageFilterProvider } from '@/components/page';
import { PendoPlaceholder } from '@/components/PendoPlaceholder';

import EventLogContent from './EventLogContent';

const DEFAULT_QUERY_STATE: Partial<QueryState> = {
  size: 20,
  sortBy: 'occurredAt',
  sortOrder: InstantSearchSortOrder.DESC,
};

const EventLog = () => {
  return (
    <Page title={t`Settings`} pageName={t`Event Log`} exampleAIQuestions={[]}>
      <InstantSearch prefix="e" defaultQueryState={DEFAULT_QUERY_STATE}>
        <PageFilterProvider>
          <div className="flex w-full flex-col gap-6">
            <div className="flex justify-between">
              <PageDateRangeFilter />
              <div className="flex items-center gap-2">
                <PendoPlaceholder />
                <InstantSearchInput />
              </div>
            </div>
            <EventLogContent />
          </div>
        </PageFilterProvider>
      </InstantSearch>
    </Page>
  );
};

export default EventLog;
